<template>
  <div class="row col-12 ml-0 pl-0 mr-0 pr-0">
    <div class="Registro--header">
      <div class="ml-3 d-flex align-items-center justify-content-center"
           :class="{ 'Registro_titulo_nascimento_casamento': ['N', 'C'].indexOf(propRegistro.tipo_registro) >= 0,
                     'Registro_titulo_cas_reg': propRegistro.tipo_registro === 'CR',
                     'Registro_titulo_hab': propRegistro.tipo_registro === 'D',
                     'Registro_titulo_obito': ['NT', 'O'].indexOf(propRegistro.tipo_registro) >= 0 }">
        <icon-svg v-if="['C', 'CR', 'D'].indexOf(propRegistro.tipo_registro) >= 0"
                  icon="engagement"
                  class="icon--sm" />

        <icon-svg v-if="propRegistro.tipo_registro === 'N'"
                  icon="nascimento"
                  class="icon--sm" />

        <icon-svg v-if="['NT', 'O'].indexOf(propRegistro.tipo_registro) >= 0"
                  icon="flower"
                  class="icon--sm" />

        <h5 class="ml-2 Registro--tipo">
          {{ propRegistro.tipo_registro === 'N' ? 'Nascimento' :
            propRegistro.tipo_registro === 'C' ? 'Casamento' :
            propRegistro.tipo_registro === 'CR' ? 'Casamento Religioso' :
            propRegistro.tipo_registro === 'D' ? 'Habilitação de Casamento' :
            ['NT', 'O'].indexOf(propRegistro.registro_id) ? 'Óbito' : '' }}
        </h5>
      </div>

      <div class="col-3 pl-4 Registro--table-width">
        <table class="Registro--table">
          <tr>
            <th>Livro</th>
            <th>Folha</th>
            <th>Termo</th>
            <th>Ocorrido</th>
            <th>Registrado</th>
          </tr>

          <tr>
            <td>{{ propRegistro.livro.num_livro }}</td>
            <td>{{ propRegistro.folha }}</td>
            <td>{{ propRegistro.termo }}</td>
            <td>{{ (propRegistro.data_ocorrido || '') }}</td>
            <td>{{ (propRegistro.data_registro || '') }}</td>
          </tr>
        </table>
      </div>

      <div v-if="propRegistro.livro.cartorio.endereco"
           class="col pl-2 d-flex align-items-center">
        <icon-svg icon="mapMarker"
                  class="icon--sm" />

        <table class="Registro--cartorio">
          <tr>
            <th>
              <b>{{ propRegistro.livro.cartorio.endereco.cidade + '/' + propRegistro.livro.cartorio.endereco.uf }}</b>
            </th>
          </tr>

          <tr>
            <td>
              <b>{{ propRegistro.livro.cartorio.nome }}</b>
            </td>
          </tr>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
  export default {
    name: 'HeaderBoxRegistro',
    props: {
      propRegistro: { type: Object, default: () => ({}) }
    }
  }
</script>

<style lang="scss" scoped>
  @import '@/scss/_utilities/_exports';

  .Registro {
    &--header {
      background-color: $sofiaRei-blue;
      min-height: 30px;
      display: flex;
      align-content: center;
      width: 100%;
    }

    &--tipo {
      font-size: 1rem;
    }

    &--table-width {
      flex: 0 0 28%;
      max-width: 28%;
    }

    &--table {
      font-size: 12px;
      & tr:first-child {
        border-bottom: 1px solid black;
      }

      & th, td {
        padding-left: 6px;
        padding-right: 6px;
      }
    }

    &--cartorio {
      font-size: 14px;
    }

    &_titulo_nascimento_casamento {
      flex: 0 0 10%;
      max-width: 10%;
    }

    &_titulo_cas_reg {
      flex: 0 0 16%;
      max-width: 16%;
    }

    &_titulo_hab {
      flex: 0 0 19%;
      max-width: 19%;
    }

    &_titulo_obito {
      flex: 0 0 6%;
      max-width: 6%;
    }
  }
</style>